import chroma from 'chroma-js';
import { useMemo } from 'react';
import { palette } from '../../theme/colors';
import { ReactComponent as WarningTriangleIcon } from '../../assets/icons/warning-triangle-transparent-exclamation-mark.svg';
import { SContainer, SIconContainer, SInstructionsText } from './AlarmInstructionsBar.styles';

type Props = {
  alarmColor: string;
  instructions: string;
};

export const AlarmInstructionsBar = ({ alarmColor, instructions }: Props) => {
  const safeAlarmColor = useMemo(
    () => (chroma.valid(alarmColor) ? alarmColor : palette.redAlert),
    [alarmColor]
  );
  const backgroundColor = useMemo(
    () => chroma(safeAlarmColor).luminance(0.01).hex(),
    [safeAlarmColor]
  );

  return (
    <SContainer
      style={{
        backgroundColor: backgroundColor,
        borderColor: safeAlarmColor,
      }}
    >
      <SIconContainer style={{ backgroundColor: safeAlarmColor }}>
        <WarningTriangleIcon width={22} height={22} />
      </SIconContainer>
      <SInstructionsText>{instructions}</SInstructionsText>
    </SContainer>
  );
};
